import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Position } from 'coreOld/enums';
import { theme } from 'coreOld/themes';

export const textFieldStyle = {
  border: `1px solid ${theme.palette.borderColor}`,
};

interface StyledDivProps {
  children?: ReactNode;
  border?: any;
  style?: any;
}

export const FiltersBar = styled.div<StyledDivProps>`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  margin-top: -2px;
  min-height: ${({ theme }) => theme.filterBarHeight}px;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
`;

export const FieldWrapper = styled.div<StyledDivProps>`
  width: 100%;
`;

export const ButtonWrapper = styled.div<StyledDivProps>`
  height: 100%;
  display: flex;
`;

export const Section = styled.div<StyledDivProps>`
  padding: 8px 4px;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.tableBorderColor}`};
  margin-bottom: -2px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1 1 auto;

  ${({ border }) => {
    switch (border) {
      case Position.LEFT:
        return css`
          border-left: ${({ theme }) => `1px solid ${theme.palette.tableBorderColor}`};
        `;
      case Position.RIGHT:
        return css`
          border-right: ${({ theme }) => `1px solid ${theme.palette.tableBorderColor}`};
        `;
      default:
        return css``;
    }
  }};
`;
